<template>
<v-flex :class="{'course-aside': $vuetify.breakpoint.mdAndUp}" class="wrapper-relative">
<div class="course-aside__wrapper js-course-sidebar" :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
  <v-flex :class="{'background-light': $vuetify.breakpoint.xs}">
    <courseProgress v-if="!isScorm" :course_completed="course_completed" :class="{'px-3 pt-3': $vuetify.breakpoint.xs}">
      <!-- course_completed ? percent(points_required_test,points_total_test)+  -->
      <v-flex v-if="points_required_test > 0 || type !== 'newcourse'">
        {{ course_completed && (lessons_passed <= lessons_total) ? percent(points_required_test,points_total_test) + $t('% необходимо набрать для успешного прохождения курса') : $t('100% уроков необходимо пройти для получения доступа к итоговому тесту') }}
      </v-flex>
    </courseProgress>

    <v-flex  v-if="isScorm">
      <v-layout v-if="!course_started && !course_completed"><buttonRed :disabled="isDisabledByUserStatus" class="flex xs12" :class="{'mx-3': $vuetify.breakpoint.xs}" @click.native="activateScormCourse(course_id)">{{ $t("Активировать курс") }}</buttonRed></v-layout>
      <br />
      <v-layout v-if="!test_finished && blocks && blocks.length > 0"><buttonBdWhite class="flex xs12" :class="{'mx-3': $vuetify.breakpoint.xs}" @click.native="toggleScormCourseShown()">{{ isScormCourseShown ? 'Перейти к тесту' : 'Перейти к содержанию курса' }}</buttonBdWhite></v-layout>
      <br />
      <v-layout v-if="!isDisabledByUserStatus && !test_finished && !isScormCourseShown && course_started && !isScormTestStarted"><buttonBdWhite class="flex xs12" :class="{'mx-3': $vuetify.breakpoint.xs}" @click.native="toggleScormTest()">{{ isScormTestStarted ? 'Приостановить тест' : 'Начать тест' }}</buttonBdWhite></v-layout>
    </v-flex>

    <v-layout v-if="!course_started && !course_completed && !isScorm"><buttonRed class="flex xs12" :class="{'mx-3': $vuetify.breakpoint.xs}" @click.native="course_activate(course_id)">{{ $t("Активировать курс") }}</buttonRed></v-layout>

    <!-- v-if убрал условие  && lessons_passed >= lessons_total-1 -->
    <buttonRed v-if="points_required_test > 0 && test_attempts > 0 && course_completed && !test_started && !isScorm" :class="{'mx-3': $vuetify.breakpoint.xs}" @click.native="next_step()">{{ test_finished || completed_date ? $t('Пройти тестирование заново') : $t('Пройти итоговое тестирование') }}</buttonRed>

    <buttonBdWhite v-if="test_started && test_layout && !isScorm" :class="{'mx-3': $vuetify.breakpoint.xs}"
                   class="mb-4" @click.native="interrupt_test()"
    >{{ $t("Прервать тестирование") }}</buttonBdWhite>

    <buttonBdWhite v-if="test_started && !test_layout && !test_finished && !isScorm" :class="{'mx-3': $vuetify.breakpoint.xs}" @click.native="test_resume_handle">{{ $t("Вернуться к тесту") }}</buttonBdWhite>

    <v-layout v-if="!course_completed || points_earned_test < points_required_test" row :class="{'background-light pa-3': $vuetify.breakpoint.xs, 'mt-4 mb-3': $vuetify.breakpoint.smAndUp}">
      <svg v-svg
           symbol="hourglass"
           size="16 16"
           class="icon-small red-text"
           role="presentation"
      />
      <v-flex class="red-text text-uppercase ml-3"> {{ show_rest_time }}</v-flex>
    </v-layout>
    <!-- <div v-if="course_started" class="red-text" :class="{'pb-4 px-3': $vuetify.breakpoint.xs, 'mb-3': $vuetify.breakpoint.smAndUp}">{{$t("Осталось попыток")}}: {{ test_attempts }}</div>-->
  </v-flex>

  <v-layout v-if="course_started && points_required_test && !isScorm" column>
    <v-flex v-for="(block, i) in blocks" :key="i" class="my-4">
      <stepper v-if="block.lessons" :block_index='i' :steps="block.lessons"><span v-html="block.text"></span></stepper>
    </v-flex>
  </v-layout>

  <v-layout v-if="isScorm && isScormCourseShown" column>
    <v-flex v-for="(block, i) in blocks" :key="i" class="my-4">
      <stepper v-if="block.lessons" :block_index='i' :steps="block.lessons"><span v-html="block.text"></span></stepper>
    </v-flex>
  </v-layout>
</div>
</v-flex>
</template>

<script>
import courseProgress from '@/components/view_blocks/Course/course_progress';
import stepper from '@/components/blocks/stepper/stepper.vue';
import buttonRed from '@/components/ui/buttons/button_red.vue';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white.vue';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import api from '@/api';

export default {
  components: {
    stepper,
    courseProgress,
    buttonRed,
    buttonBdWhite,
  },
  data() {
    return {
      contentPositionTop: 0,
      asideHeight       : 0,
    };
  },
  props: {
    isScorm: {
      type: Boolean
    },
    isBusinessPlus: {
      type: Boolean
    },
    isScormCourseShown: {
      type: Boolean,
    },
    isScormTestStarted: {
      type: Boolean,
    },
    isDisabledByUserStatus: {
      type: Boolean,
    }
  },
  computed: {
    ...mapGetters('course_info/content', [
      'course_id',
    ]),
    ...mapState('course_info', [
      'course_name',
    ]),
    ...mapGetters('course_info/steps', [
      'lessons_total',
      'active_step',
      'blocks',
      'items_for_block',
    ]),
    ...mapGetters('course_info', [
      'snackbar',
      'course_started',
      'course_completed',
      'course_rest_time',
      'test_started',
      'test_finished',
      'points_required_test',
      'points_earned_test',
      'points_total_test',
      'time_test',
      'lessons_passed',
      'test_attempts',
      'completed_date',
      'time_left',
      'type',
    ]),
    ...mapGetters('course_info/modals', [
      'modal_test_cancel',
    ]),
    ...mapGetters('testing', [
      'test_layout',
    ]),
    show_rest_time() {
      if (this.time_left == 0) {
        return this.$t('Просрочен');
      } else if (this.course_rest_time.includes(this.$t('1 день'))) {
        return this.$t('Остался') + ' ' + this.course_rest_time;
      } else {
        return this.$t('Осталось') + ' ' + this.course_rest_time;
      }
    },
  },
  updated() {
    window.scroll(0, 0);

    this.$nextTick(() => {
      let headerHeightWithMargin = 75;

      this.asideHeight = document.querySelector('.js-course-sidebar').offsetHeight;
      this.contentPositionTop = document.querySelector('.js-course-content')
          ? document.querySelector('.js-course-content').offsetTop - headerHeightWithMargin
          : document.querySelector('.js-test-content').offsetTop - headerHeightWithMargin;

      this.handleScroll();
    });
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async activateScormCourse(id) {
      this.$emit('update:isScormTestActivated', true);
      await this.course_activate(id).then(() => {
        api.course.test_start(id)
      });
    },
    toggleScormCourseShown() {
      this.$emit('update:isScormCourseShown', !this.isScormCourseShown);
      this.$emit('update:isScormTestStarted', !this.isScormTestStarted);
    },
    toggleScormTest() {
      this.$emit('update:isScormTestStarted', !this.isScormTestStarted);
    },
    test_resume_handle() {
      this.SET_ACTIVE_COURSE({id: this.course_id, name: this.course_name});
      this.add_course_in_timer();
      this.test_resume();
    },
    async interrupt_test() {
      await this.interrupted_timer();

      this.SET_STATE_COURSE({type: 'interrupt_test', items: true});
      this.test_hide();
    },
    handleScroll() {
      let scrolled = window.pageYOffset || document.body.scrollTop;
      let contentEl = document.querySelector('.js-course-content');
      let body = document.body;
      let needScroll = scrolled - this.contentPositionTop + 'px';
      let sidebar = document.querySelector('.js-course-sidebar');
      let footerHeight = 320;

      if (contentEl && sidebar && (contentEl.offsetHeight > sidebar.offsetHeight)) {
        if (scrolled > this.contentPositionTop && scrolled < body.scrollHeight - (footerHeight + this.asideHeight)) {
          sidebar.style.transform = `translateY(${needScroll})`;
        } else if (scrolled < 250) {
          sidebar.style.transform = 'translateY(0px)';
        }
      } else {
        sidebar.style.transform = 'translateY(0px)';
      }
    },
    percent: function(required, total) {
      return 85;
      /*
        if (required<total) {
          return Math.round((required/total)*100, 0);
        } else return 100;
      */
    },
    ...mapActions('testing', [
      'test_resume',
      'test_cancel_modal',
      'test_hide',
      'add_course_in_timer',
      'interrupted_timer',
    ]),
    ...mapMutations('course_info', [
      'SET_STATE_COURSE',
      'SET_ACTIVE_COURSE',
    ]),
    ...mapMutations('course_info/modals', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('course_info/steps', [
      'next_step',
    ]),
    ...mapActions('course_info', [
      'course_activate',
    ]),
  },
};
</script>
